export const REPORT_LAYOUT_ID = 'reportLayout';
export const ROOT_CONTROL_ID = 'formBox';

export const REPORT_CONTROL_TYPE = {
  LAYOUT: 'layout',
  REPORT_INFO: 'ssReport',
  REPORT_LAYOUT: 'reportLayout',
  FILTER_AND_SORT: 'filterAndSort',
  DISTRIBUTION_TAB: 'distribution',
  PAGE_HEADER_WRAPPER: 'pageHeader',
  TOP_CHART: 'topChartContainer',
  BOTTOM_CHART: 'bottomChartContainer',
  CROSS_TAB_CONTAINER: 'crossTabContainer',
  GROUP_HEADER_CONTAINER: 'groupHeaderContainer',
  DATA_COLUMN_CONTAINER: 'dataColumnContainer',
  PAGE_FOOTER_WRAPPER: 'pageFooter',
  FILTER_CONDITION_CONTAINER: 'filterContainer',
  DATA_FILTER_CONDITION_CONTAINER: 'dataFilterContainer',
  SORT_CONDITION_CONTAINER: 'sortContainer',
  DISTRIBUTION: 'distribution',
  PAGE_HEADER: 'ssPageHeader',
  PAGE_FOOTER: 'ssPageFooter',
  CROSS_TAB_DATA: 'ssCrossTabData',
  CROSS_TAB_COLUMN: 'ssCrossTabColumn',
  CROSS_TAB_ROW: 'ssCrossTabRow',
  CROSS_TAB: 'ssCrossTab',
  CHART_GROUP: 'ssChartGroup',
  CHART_VALUE: 'ssChartValue',
  GROUP_TREND: 'ssGroupTrend',
  GROUP_HEADER: 'ssGroupHeader',
  DATA_COLUMN: 'ssDataColumn',
  CHART: 'ssChart',
  FILTER_CONDITION: 'ssFilterCondition',
  DATA_FILTER_CONDITION: 'ssDataFilterCondition',
  SORT_CONDITION: 'ssSortCondition',
};

export const LEGACY_CONTAINER_IDS = {
  topChart: REPORT_CONTROL_TYPE.TOP_CHART,
  crossTab: REPORT_CONTROL_TYPE.CROSS_TAB_CONTAINER,
  groupHeaderLayout: REPORT_CONTROL_TYPE.GROUP_HEADER_CONTAINER,
  dataTableLayout: REPORT_CONTROL_TYPE.DATA_COLUMN_CONTAINER,
  bottomChart: REPORT_CONTROL_TYPE.BOTTOM_CHART,
  recordFilter: REPORT_CONTROL_TYPE.FILTER_CONDITION_CONTAINER,
  dataFilterDefinition: REPORT_CONTROL_TYPE.DATA_FILTER_CONDITION_CONTAINER,
  sortDefinition: REPORT_CONTROL_TYPE.SORT_CONDITION_CONTAINER,
};

export const CONTAINERS_LABELS = {
  [REPORT_CONTROL_TYPE.LAYOUT]: 'Layout',
  [REPORT_CONTROL_TYPE.FILTER_AND_SORT]: 'Filter and Sort',
  [REPORT_CONTROL_TYPE.DISTRIBUTION]: 'Distribution',
  [REPORT_CONTROL_TYPE.REPORT_LAYOUT]: 'Report',
  [REPORT_CONTROL_TYPE.PAGE_HEADER_WRAPPER]: 'Page Header',
  [REPORT_CONTROL_TYPE.TOP_CHART]: 'Top Chart(s)',
  [REPORT_CONTROL_TYPE.CROSS_TAB_CONTAINER]: 'Cross Tab(s)',
  [REPORT_CONTROL_TYPE.GROUP_HEADER_CONTAINER]: 'Group(s)',
  [REPORT_CONTROL_TYPE.DATA_COLUMN_CONTAINER]: 'Report Data',
  [REPORT_CONTROL_TYPE.BOTTOM_CHART]: 'Bottom Chart(s)',
  [REPORT_CONTROL_TYPE.PAGE_FOOTER_WRAPPER]: 'Page Footer',
  [REPORT_CONTROL_TYPE.FILTER_CONDITION_CONTAINER]: 'Report Filter',
  [REPORT_CONTROL_TYPE.DATA_FILTER_CONDITION_CONTAINER]: 'Data Filter',
  [REPORT_CONTROL_TYPE.SORT_CONDITION_CONTAINER]: 'Sort',
};

export const CONTAINERS_WITH_WITH_CHILDREN = [
  REPORT_CONTROL_TYPE.LAYOUT,
  REPORT_CONTROL_TYPE.FILTER_AND_SORT,
  REPORT_CONTROL_TYPE.TOP_CHART,
  REPORT_CONTROL_TYPE.CROSS_TAB_CONTAINER,
  REPORT_CONTROL_TYPE.GROUP_HEADER_CONTAINER,
  REPORT_CONTROL_TYPE.DATA_COLUMN_CONTAINER,
  REPORT_CONTROL_TYPE.BOTTOM_CHART,
  REPORT_CONTROL_TYPE.DATA_FILTER_CONDITION_CONTAINER,
  REPORT_CONTROL_TYPE.FILTER_CONDITION_CONTAINER,
  REPORT_CONTROL_TYPE.SORT_CONDITION_CONTAINER,
];

export const CONTAINERS_AS_CONTROLS = [
  REPORT_CONTROL_TYPE.PAGE_HEADER_WRAPPER,
  REPORT_CONTROL_TYPE.PAGE_FOOTER_WRAPPER,
];

export const CONTROL_TYPES_WITH_PROPERTIES = [
  REPORT_CONTROL_TYPE.PAGE_HEADER,
  REPORT_CONTROL_TYPE.PAGE_FOOTER,
  REPORT_CONTROL_TYPE.CHART,
  REPORT_CONTROL_TYPE.GROUP_HEADER,
  REPORT_CONTROL_TYPE.GROUP_TREND,
  REPORT_CONTROL_TYPE.DATA_COLUMN,
  REPORT_CONTROL_TYPE.CROSS_TAB,
  REPORT_CONTROL_TYPE.CROSS_TAB_ROW,
  REPORT_CONTROL_TYPE.CROSS_TAB_COLUMN,
  REPORT_CONTROL_TYPE.CROSS_TAB_DATA,
  REPORT_CONTROL_TYPE.CHART_GROUP,
  REPORT_CONTROL_TYPE.CHART_VALUE,
];

export const CONTROL_TYPES_WITHOUT_ACTIONS = [
  REPORT_CONTROL_TYPE.PAGE_HEADER,
  REPORT_CONTROL_TYPE.PAGE_FOOTER,
];

export const CONTROL_TYPES_WITH_ACTIONS_UNDER_CONTROL = [
  REPORT_CONTROL_TYPE.GROUP_TREND,
  REPORT_CONTROL_TYPE.DATA_COLUMN,
  REPORT_CONTROL_TYPE.CROSS_TAB_ROW,
  REPORT_CONTROL_TYPE.CROSS_TAB_COLUMN,
  REPORT_CONTROL_TYPE.CROSS_TAB_DATA,
  REPORT_CONTROL_TYPE.CHART_GROUP,
  REPORT_CONTROL_TYPE.CHART_VALUE,
];

export const INLINE_CONTROL_TYPES = [
  REPORT_CONTROL_TYPE.CHART_GROUP,
  REPORT_CONTROL_TYPE.CROSS_TAB_COLUMN,
  REPORT_CONTROL_TYPE.CROSS_TAB_DATA,
  REPORT_CONTROL_TYPE.GROUP_TREND,
  REPORT_CONTROL_TYPE.DATA_COLUMN,
];

export const CONTROL_TYPES_WITH_MARGIN_BOTTOM = [
  REPORT_CONTROL_TYPE.CHART,
  REPORT_CONTROL_TYPE.CROSS_TAB,
  REPORT_CONTROL_TYPE.GROUP_HEADER,
  REPORT_CONTROL_TYPE.CROSS_TAB_ROW,
];

export const CROSS_TAB_CHILDREN = [
  REPORT_CONTROL_TYPE.CROSS_TAB_ROW,
  REPORT_CONTROL_TYPE.CROSS_TAB_COLUMN,
  REPORT_CONTROL_TYPE.CROSS_TAB_DATA,
];

export const CONTROL_TYPES_WITH_SIMPLE_BLOCK_STYLES = [
  REPORT_CONTROL_TYPE.CHART_VALUE,
  REPORT_CONTROL_TYPE.CHART_GROUP,
  REPORT_CONTROL_TYPE.GROUP_TREND,
  REPORT_CONTROL_TYPE.DATA_COLUMN,
  REPORT_CONTROL_TYPE.CROSS_TAB_COLUMN,
  REPORT_CONTROL_TYPE.CROSS_TAB_DATA,
];

export const MOVE_BUTTON_TYPES = {
  UP: 'UP',
  DOWN: 'DOWN',
};

export const SELECT = 'SELECT';
export const CONDITIONAL_SELECT = 'CONDITIONAL_SELECT';
export const CONDITIONAL_TEXT_FIELD = 'CONDITIONAL_TEXT_FIELD';
export const RADIO = 'RADIO';

export const EXPRESSION_EDITOR_DEFAULT_HEIGHT = 550;
export const EXPRESSION_EDITOR_MIN_HEIGHT_COEFFICIENT = 0.3;
export const EXPRESSION_EDITOR_MAX_HEIGHT_COEFFICIENT = 0.7;
export const EXPRESSION_EDITOR_TEXT_FIELD_OFFSET = 25;

export const REPORT_MODEL_ATTRIBUTES = {
  CONTROL_TYPE: 'controlType',
};

export const PROPERTIES_WITH_ROOT_ENTITY_SELECT = [
  'dataMember',
  'groupDataMember',
  'dataFilterMember',
];

export const PROPERTIES_WITH_ENTITY_FIELDS_SELECT = [
  'value',
  'dataField',
  'category',
  'categoryLabel',
  'columnGroupDisplay',
  'dataField',
  'rowGroupDisplay',
  'groupByColumn',
  'groupHeaderDisplay',
  'groupHeaderSummaryColumn',
  'groupFooterDisplay',
  'groupFooterSummaryColumn',
  'groupDataField',
  'dataFilterField',
];

export const MAPPING_SOURCES = {
  ENTITY_NAME: 'entityName', // e.g. A.SS_NC
  ENTITY_FIELD: 'entityField', // e.g. A.NC_AGE
  TRANSLATED_ENTITY_FIELD: 'translatedEntityField', // e.g. Age of NC
  EXPRESSION_ENTITY_FIELD: 'expressionEntityField', // e.g. {|Age of NC|A.NC_AGE|}
};

export const FIELDS_MAPPING_FOR_NEW_CONTROL = {
  [REPORT_CONTROL_TYPE.CHART]: [{ propName: 'chartType', source: 'chartType' }],
  [REPORT_CONTROL_TYPE.CHART_VALUE]: [
    { propName: 'dataMember', source: MAPPING_SOURCES.ENTITY_NAME },
    { propName: 'value', source: MAPPING_SOURCES.ENTITY_FIELD },
    { propName: 'valueLabel', source: MAPPING_SOURCES.TRANSLATED_ENTITY_FIELD },
  ],
  [REPORT_CONTROL_TYPE.CHART_GROUP]: [
    { propName: 'dataMember', source: MAPPING_SOURCES.ENTITY_NAME },
    { propName: 'category', source: MAPPING_SOURCES.ENTITY_FIELD },
    { propName: 'categoryLabel', source: MAPPING_SOURCES.ENTITY_FIELD },
  ],
  [REPORT_CONTROL_TYPE.CROSS_TAB_ROW]: [
    { propName: 'dataMember', source: MAPPING_SOURCES.ENTITY_NAME },
    { propName: 'dataField', source: MAPPING_SOURCES.ENTITY_FIELD },
    { propName: 'rowGroupDisplay', source: MAPPING_SOURCES.ENTITY_FIELD },
  ],
  [REPORT_CONTROL_TYPE.CROSS_TAB_COLUMN]: [
    { propName: 'dataMember', source: MAPPING_SOURCES.ENTITY_NAME },
    { propName: 'dataField', source: MAPPING_SOURCES.ENTITY_FIELD },
    { propName: 'columnGroupDisplay', source: MAPPING_SOURCES.ENTITY_FIELD },
  ],
  [REPORT_CONTROL_TYPE.CROSS_TAB_DATA]: [
    { propName: 'dataMember', source: MAPPING_SOURCES.ENTITY_NAME },
    {
      propName: 'dataField',
      source: MAPPING_SOURCES.EXPRESSION_ENTITY_FIELD,
      expression: 'Count(VALUE_TO_REPLACE)',
    },
    { propName: 'label', source: MAPPING_SOURCES.TRANSLATED_ENTITY_FIELD },
  ],
  [REPORT_CONTROL_TYPE.GROUP_HEADER]: [
    { propName: 'dataMember', source: MAPPING_SOURCES.ENTITY_NAME },
    { propName: 'groupByColumn', source: MAPPING_SOURCES.ENTITY_FIELD },
    { propName: 'groupHeaderDisplay', source: MAPPING_SOURCES.ENTITY_FIELD },
  ],
  [REPORT_CONTROL_TYPE.DATA_COLUMN]: [
    { propName: 'dataMember', source: MAPPING_SOURCES.ENTITY_NAME },
    { propName: 'dataField', source: MAPPING_SOURCES.ENTITY_FIELD },
    { propName: 'label', source: MAPPING_SOURCES.TRANSLATED_ENTITY_FIELD },
  ],
  [REPORT_CONTROL_TYPE.GROUP_TREND]: [
    { propName: 'groupDataMember', source: MAPPING_SOURCES.ENTITY_NAME },
    { propName: 'groupDataField', source: MAPPING_SOURCES.ENTITY_FIELD },
    { propName: 'label', source: MAPPING_SOURCES.TRANSLATED_ENTITY_FIELD },
  ],
};

export const TABS_HEIGHT = 48;

export const TABS_MARGIN_BOTTOM = 8;

export const DEFAULT_CONTROLS_PROPERTIES = {
  [REPORT_CONTROL_TYPE.REPORT_INFO]: {
    pageWidth: '8.5',
    pageHeight: '11',
    distinctValuesOnly: false,
  },
  [REPORT_CONTROL_TYPE.PAGE_HEADER]: {
    visible: true,
    printOnFirstPage: true,
    printOnLastPage: true,
    showFilterCondition: 'none',
    showPageNumber: false,
    showPrintByAndDate: false,
    height: '1',
  },
  [REPORT_CONTROL_TYPE.PAGE_FOOTER]: {
    visible: true,
    printOnFirstPage: true,
    printOnLastPage: true,
    showFilterCondition: 'none',
    showPageNumber: false,
    showPrintByAndDate: false,
  },
  [REPORT_CONTROL_TYPE.SORT_CONDITION]: {
    sort: 'ASC',
  },
  [REPORT_CONTROL_TYPE.DATA_FILTER_CONDITION]: {
    openGroup: '',
    condition: 'EQ',
    closeGroup: '',
    operator: '',
  },
  [REPORT_CONTROL_TYPE.FILTER_CONDITION]: {
    openGroup: '',
    translateLabel: false,
    condition: 'EQ',
    showValues: false,
    validateValue: 'SkipBlank',
    closeGroup: '',
    operator: '',
    allowChange: false,
  },
  [REPORT_CONTROL_TYPE.CROSS_TAB]: {
    layoutDirection: 'LTR',
    dynamicCell: 'column',
  },
  [REPORT_CONTROL_TYPE.CROSS_TAB_COLUMN]: {
    visibleWhileScrolling: false,
    showSubTotal: false,
    sort: 'ASC',
  },
  [REPORT_CONTROL_TYPE.CROSS_TAB_ROW]: {
    visibleWhileScrolling: false,
    showSubTotal: false,
    sort: 'ASC',
  },
  [REPORT_CONTROL_TYPE.GROUP_TREND]: {
    translateLabel: false,
    markerType: 'None',
    theme: '1',
  },
  [REPORT_CONTROL_TYPE.GROUP_HEADER]: {
    groupHeaderVisible: true,
    sort: 'ASC',
    groupHeaderSummaryType: 'none',
    groupHeaderRepeatOnNewPage: false,
    groupFooterVisible: true,
    groupFooterSummaryType: 'Count',
    theme: '1',
  },
  [REPORT_CONTROL_TYPE.DATA_COLUMN]: {
    translateLabel: false,
    format: 'none',
    color: 'none',
    backGroundColor: 'none',
    fontFamily: 'none',
  },
  [REPORT_CONTROL_TYPE.CHART]: {
    chartType: 'Column',
    height: '4',
    showLegend: true,
    legendLayout: 'Column',
    insidePlotArea: false,
    legendPosition: 'RightCenter',
    palette: 'Default',
    showGridLines: false,
    threeDEffect: false,
    dynamicSeries: false,
    sort: 'ASC',
  },
  [REPORT_CONTROL_TYPE.CHART_GROUP]: {
    sort: 'ASC',
  },
  [REPORT_CONTROL_TYPE.CHART_VALUE]: {
    showPointLabel: false,
    plotDataAsLine: false,
    valueType: 'other',
  },
};

export const NEW_CONTROL_TYPE_BY_CONTAINER_TYPE = {
  [REPORT_CONTROL_TYPE.BOTTOM_CHART]: REPORT_CONTROL_TYPE.CHART,
  [REPORT_CONTROL_TYPE.TOP_CHART]: REPORT_CONTROL_TYPE.CHART,
  [REPORT_CONTROL_TYPE.CROSS_TAB_CONTAINER]: REPORT_CONTROL_TYPE.CROSS_TAB,
  [REPORT_CONTROL_TYPE.GROUP_HEADER_CONTAINER]: REPORT_CONTROL_TYPE.GROUP_HEADER,
  [REPORT_CONTROL_TYPE.DATA_COLUMN_CONTAINER]: REPORT_CONTROL_TYPE.DATA_COLUMN,
};

export const ADD_NEW_BUTTON_LABEL = {
  [REPORT_CONTROL_TYPE.CHART]: 'Chart',
  [REPORT_CONTROL_TYPE.CROSS_TAB]: 'Cross Tab',
  [REPORT_CONTROL_TYPE.CROSS_TAB_COLUMN]: 'Column',
  [REPORT_CONTROL_TYPE.CROSS_TAB_DATA]: 'Data Value',
  [REPORT_CONTROL_TYPE.CROSS_TAB_ROW]: 'Row',
  [REPORT_CONTROL_TYPE.CHART_GROUP]: 'Chart Group',
  [REPORT_CONTROL_TYPE.CHART_VALUE]: 'Chart Value',
  [REPORT_CONTROL_TYPE.GROUP_HEADER]: 'Group',
  [REPORT_CONTROL_TYPE.DATA_COLUMN]: 'Data Column',
  [REPORT_CONTROL_TYPE.GROUP_TREND]: 'Trend',
};

export const DEFAULT_CHILDREN_CONTROLS = {
  [REPORT_CONTROL_TYPE.CHART]: [REPORT_CONTROL_TYPE.CHART_GROUP, REPORT_CONTROL_TYPE.CHART_VALUE],
  [REPORT_CONTROL_TYPE.CROSS_TAB]: [
    REPORT_CONTROL_TYPE.CROSS_TAB_COLUMN,
    REPORT_CONTROL_TYPE.CROSS_TAB_ROW,
    REPORT_CONTROL_TYPE.CROSS_TAB_DATA,
  ],
};

export const NOTIFICATION_FREQUENCY_OPTIONS = [
  { value: 0, label: 'Daily' },
  { value: 1, label: 'Weekly' },
  { value: 2, label: 'Monthly' },
  { value: 3, label: 'Quarterly' },
];

export const CONTROLS_WITH_SPECIAL_MOVEMENT = [
  ...CROSS_TAB_CHILDREN,
  REPORT_CONTROL_TYPE.CHART_GROUP,
  REPORT_CONTROL_TYPE.CHART_VALUE,
];

export const CONTROL_TYPES_WITH_DEFAULT_DATA_MEMBER = [
  REPORT_CONTROL_TYPE.CHART,
  REPORT_CONTROL_TYPE.CHART_GROUP,
  REPORT_CONTROL_TYPE.CHART_VALUE,
  REPORT_CONTROL_TYPE.CROSS_TAB_COLUMN,
  REPORT_CONTROL_TYPE.CROSS_TAB_ROW,
  REPORT_CONTROL_TYPE.CROSS_TAB_DATA,
  REPORT_CONTROL_TYPE.DATA_COLUMN,
  REPORT_CONTROL_TYPE.GROUP_HEADER,
];

export const REPORT_DESIGNER_DATE_FORMAT = 'YYYY-MM-DD[T]HH:mm:ss';

export const CHART_TYPE_PICKER_TITLE = 'Select Chart Type';

export const ONE_SIDED_CONDITION_VALUES = ['ISNULL', 'ISNOTNULL'];

export const PALETTE_MAPPING = {
  Default: '#008000',
  Excel: '#9999ff',
  EarthTones: '#ff8000',
  Pastel: '#87ceeb',
  SemiTransparent: '#f86262',
};
